import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { ApolloLink } from '@apollo/client';
var userAgentLink = /*#__PURE__*/new ApolloLink(function (operation, forward) {
  if (typeof window === 'undefined') {
    operation.setContext(function (_ref) {
      var _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers;
      return {
        headers: _objectSpread(_objectSpread({}, headers), {}, {
          'user-agent': 'Crehana-Vercel'
        })
      };
    });
  }
  return forward(operation);
});
export default userAgentLink;